export default __webpack_public_path__ + "static/media/230.950cd171.gif";